import styled, { css } from 'styled-components';
import { baseStyles } from '../styles';
import { StyleProps } from './types';

export const Container = styled.span<StyleProps>`
  ${({ $variant, theme }) => css(theme.typography.variants[$variant].default)};
  ${baseStyles}
`;
